import {
  Controls,
  Player,
  PlayerEvent,
} from "@lottiefiles/react-lottie-player";
import React from "react";

interface Props {
  autoplay?: boolean;
  loop?: boolean;
  src: string | any;
  controlVisible?: boolean;
  className?: string;
  speed?: number | undefined;
  style?: React.CSSProperties;
  onEvent?: ((event: PlayerEvent) => any) | undefined;
}

export default function LottiePlayer({
  src,
  autoplay = true,
  loop = false,
  className,
  speed,
  style,
  onEvent,
  controlVisible = false,
}: Props) {
  return (
    <Player
      autoplay={autoplay}
      loop={loop}
      src={src}
      className={className}
      speed={speed}
      onEvent={onEvent}
      style={style}>
      <Controls
        visible={controlVisible}
        buttons={["play", "repeat", "frame", "debug"]}
      />
    </Player>
  );
}
